import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  CLEAR_PROFILE_ERROR
} from '../constants/profileConstants';

const initialState = {
  profileData: null,
  loading: false,
  error: null,
  isUpdating: false,
  isChangingPassword: false,
  isVerifyingEmail: false
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        profileData: action.payload,
        error: null
      };
    case FETCH_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        profileData: { ...state.profileData, ...action.payload },
        error: null
      };
    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload
      };
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isChangingPassword: true,
        error: null
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isChangingPassword: false,
        error: null
      };
    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        isChangingPassword: false,
        error: action.payload
      };
    case VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        isVerifyingEmail: true,
        error: null
      };
    case VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        isVerifyingEmail: false,
        error: null
      };
    case VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        isVerifyingEmail: false,
        error: action.payload
      };
    case CLEAR_PROFILE_ERROR:
      return {
        ...state,
        error: null
      };
    default:
      return state;
  }
};

export default profileReducer;